module.exports = __webpack_public_path__ + "static/img/en20.1e2939d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en20.jpg
// module id = GsEX
// module chunks = 1